"use client";
import { AnimatePresence, motion } from "framer-motion";
import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";

export type timeState = {
  hour: string;
  min: string;
};
interface ITimePickerProps {
  timeState: timeState;
  setTime: Dispatch<SetStateAction<timeState>>;
}

const TimePicker = ({ timeState, setTime }: ITimePickerProps) => {
  const [timePickerMode, setTimePickerMode] = useState(false);
  const [selectedHourIndex, setSelectedHourIndex] = useState(timeState.hour);
  const [selectedMinuteIndex, setSelectedMinuteIndex] = useState(timeState.min);

  const hoursRef = useRef<HTMLDivElement>(null);
  const minutesRef = useRef<HTMLDivElement>(null);
  const handleHr = (val, index) => {
    setSelectedHourIndex(index);
    setTime((p) => ({ ...p, ["hour"]: val }));
  };
  const handleMin = (val, index) => {
    setSelectedMinuteIndex(index);
    setTime((p) => ({ ...p, ["min"]: val }));
  };

  const { hour, min } = timeState;
  const time = hour + ":" + min;
  // useEffect(() => {
  //     // Scroll to the selected hour
  //     if (hoursRef.current) {
  //         const selectedHourElement = hoursRef.current.children[selectedHourIndex];

  //         if (selectedHourElement) {
  //             selectedHourElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
  //         }
  //     }
  // }, [selectedHourIndex]);

  // useEffect(() => {
  //     // Scroll to the selected minute
  //     if (minutesRef.current) {
  //         const selectedMinuteElement = minutesRef.current.children[selectedMinuteIndex];
  //         if (selectedMinuteElement) {
  //             selectedMinuteElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
  //         }
  //     }
  // }, [selectedMinuteIndex]);
  useLayoutEffect(() => {
    if (hoursRef.current) {
      const selectedHourElement = hoursRef.current?.children[selectedHourIndex];
      if (selectedHourElement) {
        selectedHourElement.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }
    }

    // Scroll to the selected minute
    if (minutesRef.current) {
      const selectedMinuteElement =
        minutesRef.current.children[selectedMinuteIndex];
      if (selectedMinuteElement) {
        selectedMinuteElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [timePickerMode]);
  const toggleTime = () => {
    setTimePickerMode((p) => !p);
  };

  const timePicker = (
    <motion.div
      className="p-4 w-[300px] bg-white shadow-lg absolute left-1/2 z-50 flex flex-col gap-2 rounded-lg"
      initial={{ opacity: 0 }}
      animate={{
        x: -150,
        y: timePickerMode ? 40 : -300,
        opacity: timePickerMode ? 1 : 0,
      }}
      exit={{ y: 80, opacity: 0 }}
    >
      <div className="flex justify-around">
        <div>Hours</div>
        <div>Mins (24 hr)</div>
      </div>
      <div className="flex h-44 overflow-hidden ">
        <div
          className="flex flex-col overflow-y-scroll gap-2 w-3/4 "
          ref={hoursRef}
        >
          {hours?.map((hr, idx) => {
            const isSelected = hr === hour;
            return (
              <button
                key={hr}
                style={{ backgroundColor: isSelected ? "#343434" : "#ddd" }}
                className={`p-2  font-medium ${
                  isSelected ? " text-white" : "bg-gray-200"
                }  rounded-lg`}
                onClick={() => (timePickerMode ? handleHr(hr, idx) : () => {})}
              >
                {hr}
              </button>
            );
          })}
        </div>
        <div
          className="flex flex-col h-64 pb-[100px] overflow-y-scroll gap-2 w-3/4"
          ref={minutesRef}
        >
          {minutes?.map((minute, idx) => {
            const isSelected = minute === min;
            return (
              <button
                key={minute}
                style={{ backgroundColor: isSelected ? "#343434" : "#ddd" }}
                className={`p-2 font-medium ${
                  isSelected ? " text-white" : "bg-gray-200"
                } rounded-lg`}
                onClick={() =>
                  timePickerMode ? handleMin(minute, idx) : () => {}
                }
              >
                {minute}
              </button>
            );
          })}
        </div>
      </div>
      <button
        style={{ backgroundColor: "#343434" }}
        className="p-2 rounded-lg bg-emerald-400 text-white"
        onClick={toggleTime}
      >
        Done
      </button>
    </motion.div>
  );

  return (
    <div className="rounded-lg flex flex-col items-center overflow-hidden ">
      <button
        className='z-20 text-sm font-bold p-2 bg-[#fff] text-["#222"] rounded-lg mb-8 justify-center items-center text-center'
        onClick={toggleTime}
      >
        {convertTo12HourFormat(time)}
      </button>
      {timePickerMode && (
        <div
          className="absolute -left-[1500px] h-screen w-[3000px] bg-black z-30 opacity-20"
          onClick={toggleTime}
        ></div>
      )}
      <AnimatePresence>{timePicker}</AnimatePresence>
    </div>
  );
};

export default TimePicker;

function convertTo12HourFormat(time24) {
  const [hours, minutes] = time24.split(":").map(Number);

  // Handle the case where minutes are 60
  const adjustedHours = minutes === 60 ? (hours + 1) % 24 : hours;

  // Determine AM or PM
  const period = adjustedHours >= 12 ? "PM" : "AM";

  // Convert hours to 12-hour format with leading zeros
  const hours12 = (adjustedHours % 12 || 12).toString().padStart(2, "0");

  // If minutes are 60, set them to 0
  const adjustedMinutes = minutes === 60 ? 0 : minutes;

  // Format the output with leading zeros
  const formattedMinutes = adjustedMinutes.toString().padStart(2, "0");

  const formattedTime12 = `${hours12}:${formattedMinutes} ${period}`;

  return formattedTime12;
}

const hours = Array.from({ length: 23 }, (_, index) => {
  if (index + 1 > 9) return index + 1 + "";
  else return "0" + (index + 1);
});
const minutes = Array.from({ length: 61 }, (_, index) => {
  if (index > 9) return index + "";
  else return "0" + index;
});
